import debug from 'debug';

const log = debug('Api');

/**
 * @deprecated use sitecore-api instead
 */
class Api {

	constructor() {
		this.settings = this.Settings();
	}

	/**
	 * @param {object} options An object with various configuration options for the request
	 * @param {object} [options.body]
	 * @param {string} [options.method] Default value is 'get'
	 * @param {string} options.url
	 */
	Url(options) {
		
		if (!options || !options.url) {
			log('Get() - Error: No url for Api given');
		}

		let fetchOptions =  {
			method: options.method ? options.method : 'get',
			credentials: 'same-origin',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		};

		// If we have a body for the request, prepare the options with its value
		if (options.body) {
			fetchOptions.body = JSON.stringify(options.body);
		}

		return new Promise((resolve, reject) => {

			let status;
			
			fetch(`${ options.url }`, fetchOptions ).then( response => {
				log('Get() - url, options, response', options.url, fetchOptions, response);
				// Store statuscode for use later in the promise chain				
				status = response.status;
				return response.text();
			}).then( text => {
				let json = {};
				// the api returns an empty response if all is good, so only parse if we have something valid to parse
				if (text !== '') {
					json = JSON.parse(text);
					log('Get() - json', json);
				}
				
				if ([200, 201].includes(status)) {
					resolve(json);	
				}
				else {
					if (typeof json === 'object') {
						json['status'] = status;
					} else {
						const message = json;
						json = {};
						json['status'] = status;
						json['message'] = message;
					}
					reject(json);	
				}

			});
		});
	}

	Settings() {
		let settings;

		try {
			settings = JSON.parse(document.body.getAttribute('data-settings'));
			if (!settings || !settings.sessionId) {
				log('API settings is not set in BODY');
			}
		}
		catch(error) {
			log(error);
		}

		return settings;
	}

}

export default Api;
